import type { MenuProps } from "@fluentui/react-components";
import { useCallback, useMemo } from "react";

import { useTranslationLang } from "@/i18n";
import { isSupportedLang } from "@/i18n/supportedLangs";

import { LANGUAGE_SELECT_RADIO_NAME } from "./constants";
import { useSetLangAndAccountLocale } from "./useSetLangAndAccountLocale";

/**
 * 言語選択行 (MenuItemRadio) の選択状態を Menu に接続する props。
 * MenuList ではなく Menu に渡す (両方に渡すと Fluent が警告を出す)。
 */
export const useLanguageSelectMenuCheckedProps = (): Required<
  Pick<MenuProps, "checkedValues" | "onCheckedValueChange">
> => {
  const { lang } = useTranslationLang();
  const setLangAndAccountLocale = useSetLangAndAccountLocale();

  const checkedValues = useMemo(
    () => ({ [LANGUAGE_SELECT_RADIO_NAME]: [lang] }),
    [lang]
  );

  const onCheckedValueChange = useCallback<
    NonNullable<MenuProps["onCheckedValueChange"]>
  >(
    (_event, { name, checkedItems }) => {
      if (name !== LANGUAGE_SELECT_RADIO_NAME) return;
      const [selected] = checkedItems;
      if (selected === undefined || !isSupportedLang(selected)) return;
      setLangAndAccountLocale(selected);
    },
    [setLangAndAccountLocale]
  );

  return { checkedValues, onCheckedValueChange };
};
